import { useAuth } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

/**
 * Bridge between AuthContext (which has user birthday) and ThemeProvider.
 * ThemeProvider needs the birthday to auto-switch modes.
 */
export const ThemeBridge = ({ children }) => {
  const { user } = useAuth();
  return (
    <ThemeProvider userBirthday={user?.birthday || null}>
      {children}
    </ThemeProvider>
  );
};
